import massPaymentsService from '@/shared/services/mass-payments.service'
import i18n from '@/app/i18n'

import { TOAST_DISPATCHERS } from '@/shared/constants/store-constants/toast'
import { MASS_PAYMENTS_DISPATCHERS } from '@/shared/constants/store-constants/massPayments'
import { checkNextPage } from '@/shared/lib/utils/pagination'

export default {
  onSearch({ commit, dispatch }, payload) {
    commit('SET_SEARCH', payload)
    dispatch(MASS_PAYMENTS_DISPATCHERS.resetStore, {}, { root: true })
    dispatch(
      MASS_PAYMENTS_DISPATCHERS.getMassPayments,
      { search: payload },
      { root: true }
    )
  },

  resetSearch({ commit, dispatch }) {
    commit('RESET_SEARCH')
    dispatch(MASS_PAYMENTS_DISPATCHERS.getMassPayments, {}, { root: true })
  },

  resetStore({ commit }) {
    commit('RESET_STORE')
  },

  changePage({ commit, dispatch, state }) {
    if (checkNextPage(state.page, state.total, state.limit)) {
      commit('SET_PAGE', state.page + 1)

      dispatch(MASS_PAYMENTS_DISPATCHERS.getMassPayments, {}, { root: true })
    }
  },

  onSelectSort({ commit, dispatch }, payload) {
    dispatch(
      MASS_PAYMENTS_DISPATCHERS.resetStore,
      { resetSort: false },
      { root: true }
    )
    commit('SET_SORT', payload)
    dispatch(MASS_PAYMENTS_DISPATCHERS.getMassPayments, {}, { root: true })
  },

  async createMassPayment({ commit, dispatch }, formData) {
    try {
      commit('SET_ACTION_LOADING', true)
      const response = await massPaymentsService.createMassPayment(formData)

      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })

      return { success: true, payload: response }
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async getMassPayments({ commit, state, dispatch }, params) {
    try {
      commit('SET_LOADING', true)
      const response = await massPaymentsService.getMassPayments({
        ...params,
        page: state.page,
        limit: state.limit,
        ...(state.search && { search: state.search }),
        sort_by: state.sort.sort_by,
        sort_direction: state.sort.sort_direction,
      })
      commit('SET_ITEMS', response.data)
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteMassPayments({ state, commit, dispatch }, payload) {
    try {
      commit('SET_ACTION_LOADING', true)
      await massPaymentsService.deleteMassPayments(payload)
      state.items = state.items.filter((item) => !payload.includes(item.id))

      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })

      return { success: true }
    } catch (error) {
      if (!error.isHandled) {
        if (error.response.data.code === 'payroll-011') {
          dispatch(
            TOAST_DISPATCHERS.setErrorMessage,
            {
              title: i18n.global.t('MassPayments | delete | error | title'),
              message: i18n.global.t('MassPayments | delete | error'),
            },
            { root: true }
          )
        } else {
          dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
        }
      }
      return { success: false }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async getTermsStatus({ commit, dispatch }) {
    try {
      const response = await massPaymentsService.getTermsStatus()
      commit('SET_TERMS_ACCEPTED', response.data.terms_accepted)
      return { success: true, payload: response.data }
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
      return { success: false }
    }
  },

  async acceptTerms({ commit, dispatch }) {
    try {
      await massPaymentsService.acceptTerms()
      commit('SET_TERMS_ACCEPTED', true)
      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })
      return { success: true }
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
      return { success: false }
    }
  },
}
